import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Layout = ({ children }) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  // Función para ir a la página de inicio correctamente
  const handleLogoClick = (e) => {
    e.preventDefault();
    // Solución simple: recargar la página
    window.location.replace('/');
  };
  
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="bg-white">
        <div className="max-w-5xl mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <a 
              href="/"
              className="flex items-center cursor-pointer hover:opacity-80 transition-opacity"
              onClick={handleLogoClick}
            >
              <img src="/logo.svg" alt="Summaly Logo" className="h-6 w-6" />
              <h1 className="ml-2 text-lg font-medium text-gray-800">{t('app.name')}</h1>
            </a>
            
            <div className="flex items-center">
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </header>
      
      <main className="flex-1 overflow-auto">
        {children}
      </main>
      
      <footer className="bg-white py-3 px-4 w-full">
        <div className="max-w-3xl mx-auto flex justify-center items-center">
          <div className="text-xs text-gray-400">{t('footer.copyright', { year: currentYear })}</div>
        </div>
      </footer>
    </div>
  );
};

export default Layout; 